module.exports = __webpack_public_path__ + "img/titles1.b6291a0b.png";